import { User } from '@/resource/user/user.model';

export enum GradeStatus {
  Open = 'open',
  InProgress = 'in_progress',
  Graded = 'graded',
}

export interface GradePaper {
  id: number;
  uuid: string;
  name: string;
  user: User;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  status: GradeStatus;
  averageScore: number;
}

export interface GradeSchema {
  id: number;
  images: string[];
  gradePaper: GradePaper;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
}

export interface GradeAnswerSheet {
  id: number;
  student: { name: string };
  status: GradeStatus;
  score: number;
  images: string[];
  gradePaper: GradePaper;
  gradeSchema: GradeSchema;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
}
